import { render, staticRenderFns } from "./nice-progress-bar.vue?vue&type=template&id=5aba72da&scoped=true"
import script from "./nice-progress-bar.vue?vue&type=script&lang=js"
export * from "./nice-progress-bar.vue?vue&type=script&lang=js"
import style0 from "./nice-progress-bar.vue?vue&type=style&index=0&id=5aba72da&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aba72da",
  null
  
)

export default component.exports